export const apiRoutes = {
    USER_ACCOUNT: "/admin/user/account",
    ADMIN_SETTINGS: "/admin/settings",
    AUTH_LOGIN: "/v2/auth/login",
    USER_ACCOUNT_LIST: "/admin/user/accounts",
    AUTH_REFRESH_TOKEN: "/auth/reset-token",
    AUTH_ADMIN_VERIFY_MFA: 'v1/auth/send-mfa-code',
    AUTH_ADMIN_VERIFY_CODE: 'v1/auth/confirm-mfa-code',
    ADMIN_KEY: "/admin/key",
    ADMIN_WEBHOOK: "/admin/webhook",
    ADMIN_WEBHOOK_SECRET: "/admin/webhook/secret",
    ADMIN_PAYMENT_URL: "/admin/payment/url",
    ADMIN_PAYMENT_URL_LIST: "/admin/payment/urls",
    PAYMENT_TRANSACTION: "/admin/payment/transactions",
    ADMIN_BALANCE: "admin/balance",
    ADMIN_STATS: "/admin/api/stats",
    STAT_TRANSACTIONS: "/statistics/transaction",
    PAYMENT_URL: "/payment/url",
    ADMIN_PRODUCT_URL: "/admin/product/url",
    ADMIN_PRODUCT_DELETE_IMAGES: "/admin/product/url/removeimages",
    ADMIN_PRODUCT_URL_DISABLE: "/admin/product/url/disable",
    SET_LANGUAGE: "/admin/user/account/lang",
    ACCOUNT_BALANCE: "/admin/balance",
    ACCOUNT_WITHDRAWALS: "/admin/withdrawals",
    ACCOUNT_WITHDRAWAL: "/admin/withdrawal",
    ACCOUNT_WITHDRAWAL_INITIATE: "/admin/withdrawal/initiate",
    ACCOUNT_WITHDRAWAL_METHOD: "/admin/withdrawal/method",
    ACCOUNT_WITHDRAWAL_METHOD_DELETE: "/admin/withdrawal/method",
    ACCOUNT_WITHDRAWAL_METHODS: "/admin/withdrawal/methods",
}